<div nbTooltip="More Details" i18n-nbTooltip style="width: 32px">
  <button
    *ngIf="_value !== '{}'"
    nbButton
    ghost
    class="action-button"
    [nbPopover]="moreDetails"
    nbPopoverTrigger="click"
    nbPopoverPlacement="bottom"
  >
    <nb-icon icon="more-horizontal-outline"></nb-icon>
  </button>
  <ng-template #moreDetails>
    <pre class="p-3 m-0 overflow-auto" style="max-width: 600px; max-height: 450px">{{ _value }}</pre>
  </ng-template>
</div>
